module.exports = __webpack_public_path__ + "static/media/infoIcon.d0ffa763.svg";